// File di traduzioni centralizzato
export const translations = {
  it: {
    // Generale
    common: {
      save: 'Salva',
      cancel: 'Annulla',
      delete: 'Elimina',
      edit: 'Modifica',
      add: 'Aggiungi',
      close: 'Chiudi',
      confirm: 'Conferma',
      search: 'Cerca',
      filter: 'Filtra',
      export: 'Esporta',
      import: 'Importa',
      settings: 'Impostazioni',
      language: 'Lingua'
    },

    // Form cavi
    cableForm: {
      standardCable: 'Cavo Standard',
      multipolarCable: 'Cavo Multipolare',
      newCable: 'Nuovo Cavo',
      editStandardCable: 'Modifica Cavo Standard',
      editMultipolarCable: 'Modifica Cavo Multipolare',
      siglatura: 'Siglatura',
      group: 'Gruppo',
      color: 'Colore',
      section: 'Sezione',
      length: 'Lunghezza',
      lengthMm: 'Lunghezza (mm)',
      terminalA: 'Terminale A',
      terminalB: 'Terminale B',
      connectionA: 'Collegamento A',
      connectionB: 'Collegamento B',
      sheath: 'Guaina',
      addSheath: 'Nuova Guaina',
      deleteSheath: 'Elimina Guaina',
      sheathType: 'Tipo Guaina',
      sheathDiameter: 'Diametro',
      sheathLength: 'Lunghezza',
      pvc: 'PVC',
      braided: 'Trecciata',
      optional: '(opzionale)',
      noSheath: 'Nessuna guaina',
      noSheathCreated: 'Nessuna guaina creata',
      enterDiameterLength: 'Inserisci diametro e lunghezza',
      deleteSheathConfirm: 'Eliminare questa guaina? I cavi che la usano verranno aggiornati.',
      addNewSheath: 'Aggiungi Nuova Guaina',
      cancel: 'Annulla',
      add: 'Aggiungi',
      diameterMm: 'Diametro (mm)',
      placeholderDiameter: 'es. 3.5, 5, 8',
      placeholderLength: 'es. 200, 500',
      sheathNote: '💡 Nota: I cavi con la stessa guaina verranno raggruppati insieme fisicamente.',
      addSheathButton: 'Aggiungi Guaina',
      cableName: 'Nome Cavo',
      baseLength: 'Lunghezza Base (mm)',
      poles: 'Poli',
      addNewPole: 'Aggiungi nuovo polo',
      pole: 'Polo',
      poleSignatureA: 'Siglatura A',
      poleSignatureB: 'Siglatura B',
      poleLengthA: 'Lunghezza A (mm)',
      poleLengthB: 'Lunghezza B (mm)',
      duplicatePole: 'Duplica questo polo',
      removePole: 'Rimuovi polo',
      addMultipolarCable: 'Aggiungi Cavo Multipolare',
      cancelEdit: 'Annulla Modifica',
      placeholderCableName: 'es. Cavo Multipolare',
      placeholderPoleSignatureA: 'es. 60, R1',
      placeholderPoleSignatureB: 'es. 61, R2',
      disabledConnectionMode: '(disabilitato - modalità collegamento)',
      disabledUseConnectionMode: 'Disabilitato - usa modalità collegamento',
      placeholderSignature: 'es. 60, R1, L',
      placeholderGroup: 'es. A, 1, GRP1',
      placeholderConnectionA: 'es. F6.7 (1), MORS. 61',
      placeholderConnectionB: 'es. MORS. 61, K6.2 (A1)',
      addCable: 'Aggiungi Cavo',
      saveChanges: 'Salva Modifiche',
      saveAsNew: 'Salva come Nuovo',
      keepAllSettings: 'Mantieni tutte le impostazioni per il prossimo cavo',
      addArrowUp: 'Aggiungi freccia UP (▲)',
      addArrowDown: 'Aggiungi freccia DOWN (▼)',
      addVirtualDot: 'Aggiungi collegamento fittizio (·)',
      swapTerminals: 'Scambia terminali e collegamenti A ↔ B'
    },

    // Lista cavi


    // Visualizzazione schematica
    schematic: {
      schematicView: 'Vista Schematica',
      schematicViewTitle: 'Vista Schematica Cavi',
      cable: 'cavo',
      cables: 'cavi',
      singleCable: 'Singolo',
      cableSegments: 'tratti di cavo',
      cableSegmentsInGroups: 'in {count} gruppi',
      cablesInSubgroups: 'cavi in {count} sottogruppi',
      group: 'Gruppo',
      forcedGroup: 'Gruppo Forzato',
      multiple: 'Multiplo',
      sheath: 'Guaina',
      multipolarCable: 'Multipolare',
      hybrid: 'Ibrido',
      groupLabel: 'Gruppo:',
      pdfColors: 'PDF Colori',
      noCablesSelected: 'Attenzione: nessun cavo selezionato per l\'esportazione.',
      sortBy: 'Ordina per:',
      numbering: 'Numerazione',
      signature: 'Siglatura',
      color: 'Colore',
      section: 'Sezione',
      colorSection: 'Colore + Sezione',
      groupSort: 'Gruppo',
      sheathLabel: 'Guaina:',
      sheathNumber: 'Guaina #{id}',
      cableLabel: 'Cavo:',
      nestedViewToggle: 'Vista annidata (beta)'
    },

    // Pannello configurazione macchina spelafili
    machineConfigPanel: {
      title: 'Configurazione Macchina',
      subtitle: 'Parametri calcolati dal cavo multipolare',
      enabled: 'ON',
      disabled: 'OFF',
      innerOff: 'Spelatura interna non richiesta',
      innerOn: 'Spelatura interna richiesta da terminali con peel'
    },

    // Messages
    messages: {
      warning: 'Avviso:',
      success: 'Successo:',
      error: 'Errore:',
      closeWarning: 'Chiudi avviso',
      closeSuccess: 'Chiudi messaggio',
      closeError: 'Chiudi errore'
    },

    // Quantities
    quantities: {
      summaryTitle: 'Riepilogo quantità',
      cableQuantities: 'Quantità Cavi',
      terminalQuantities: 'Quantità Terminali',
      sheathQuantities: 'Quantità Guaine',
      signatureCalculation: 'Calcolo Siglature e Morsetti',
      exportSignatures: 'Esporta Siglature',
      cableType: 'Tipo Cavo',
      terminalType: 'Tipo Terminale',
      sheathType: 'Tipo Guaina',
      quantity: 'Quantità',
      diameter: 'Diametro',
      totalLength: 'Lungh. Totale',
      realTotal: 'Totale Reale',
      realLength: 'Lungh. Reale',
      total: 'TOTALE',
      varieties: 'varietà',
      multipleProduction: 'Produzione Multiple: {count} cablaggi identici',
      multipleProductionDesc: 'I totali reali sono moltiplicati per {count}. Verifica le quantità prima dell\'ordine materiali.',
      cablaggi: 'CABLAGGI',
      noCablesInserted: 'Nessun cavo inserito',
      noSheaths: 'Nessuna guaina utilizzata',
      addCablesToCalculate: 'Aggiungi cavi per calcolare siglature e morsetti',
      loadingData: 'Caricamento dati...',
      summaryTotals: '📊 Riepilogo Totali',
      signatures05_15: 'Siglature 0.5-1.5 mm²',
      signatures25_6: 'Siglature 2.5-6.0 mm²',
      flatTags: 'Targhette FLAT 4x15',
      terminals: 'Morsetti',
      totalOverall: 'Totale Complessivo',
      start: 'Inizio',
      repeat: 'Ripet.',
      end: 'Fine',
      totalLabel: 'totali',
      terminal: 'Terminale',
      sheathPVC: 'PVC',
      sheathBraided: 'Trecciata'
    },

    // Cable list
    cableList: {
      cable: 'Cavo',
      cableLabel: 'Cavo:',
      connectedCables: 'cavi collegati',
      cables: 'cavi',
      multiple: 'Multiplo',
      sheath: 'Guaina',
      sheathLabel: 'Guaina:',
      subgroup: 'sottogruppo',
      subgroups: 'sottogruppi',
      inSubgroups: 'in {count} {word}',
      hasProblems: 'Ha problemi',
      noCablesInserted: 'Nessun cavo inserito',
      addCablesToSeeSchema: 'Aggiungi cavi per vedere lo schema delle connessioni',
      selected: 'selezionati',
      selectAll: 'Seleziona tutto',
      deselectAll: 'Deseleziona tutto',
      cableList: 'Elenco Cavi',
      importXlsx: 'Importa XLSX',
      exportXlsx: 'Esporta XLSX',
      sortOrder: 'Ordine:',
      selectSortType: 'Seleziona il tipo di ordinamento',
      selectCables: 'Seleziona Cavi:',
      manualSort: 'Ordina Manualmente:',
      exportForEW3035: 'Esporta per EW-3035+L:',
      deleteSelected: 'Elimina',
      deleteSelectedTitle: 'Elimina {count} cavo/i selezionato/i',
      sortByNumber: 'Numerazione',
      sortBySignature: 'Siglatura',
      sortByColor: 'Colore',
      sortBySection: 'Sezione',
      sortByColorSection: 'Colore + Sezione',
      sortByGroup: 'Gruppo',
      loading: 'Caricamento...'
    },

    // Validazione
    validation: {
      duplicateCable: 'Cavo duplicato di',
      missingSignature: 'Siglatura mancante',
      invalidTerminal: 'Terminale non valido',
      invalidColor: 'Colore non valido',
      invalidSection: 'Sezione non valida',
      hasIssues: 'Ha problemi',
      issuesList: 'Problemi:',
      terminalA: 'Terminale A',
      terminalB: 'Terminale B',
      color: 'Colore',
      terminalAError: 'Terminale A: {error}',
      terminalBError: 'Terminale B: {error}',
      colorError: 'Colore: {error}',
      sectionError: 'Sezione non valida',
      poleError: 'Polo {index}: {error}',
      cableNameMissing: 'Nome cavo mancante',
      emptyTerminal: 'Terminale vuoto',
      invalidSPLength: 'Terminale SP con lunghezza non valida: {length}',
      invalidSPPeel: 'Terminale SP con spelatura non valida: {peel}',
      unknownTerminal: 'Terminale sconosciuto: {terminal}',
      emptyColor: 'Colore vuoto',
      unknownColor: 'Colore sconosciuto: {color}',
      sectionUnderMin: 'Terminale {terminal}: sezione {sezione} inferiore al minimo (min {min})',
      sectionOverMaxTotal: 'Terminale {terminal}: sezione totale {sum} supera la capacità del terminale (max {max})',
      sectionOverMaxSingle: 'Terminale {terminal}: sezione {sezione} supera il massimo del terminale (max {max})',
      duplicateCableOf: 'Cavo duplicato di: {cables}',
      cableInsertedMissingFields: 'Cavo inserito con campi mancanti: {fields}. Puoi completarli in seguito.',
      multipolarCableInsertedMissingFields: 'Cavo multipolare inserito con campi mancanti: {fields}. Puoi completarli in seguito.'
    },

    // Operazioni file
    fileOperations: {
      exportSuccess: 'Esportazione completata',
      importSuccess: 'Importazione completata',
      fileImportedSuccess: 'File "{name}" importato correttamente!',
      fileExportedSuccess: 'File "{name}" esportato correttamente!',
      fileExportedSuccessSelected: 'File "{name}" esportato correttamente! ({exported} di {total} cavi selezionati)',
      fileExportedSuccessTotal: 'File "{name}" esportato correttamente! ({exported} cavi totali)',
      importError: 'Errore durante l\'importazione del file: {error}',
      exportError: 'Errore durante l\'esportazione: {error}',
      exportSiglatureError: 'Errore durante l\'esportazione siglature: {error}',
      exportPDFError: 'Errore esportazione PDF: {error}',
      pdfLibrariesError: 'Errore nel caricamento delle librerie PDF. Riprova.',
      noFileNameWarning: 'Attenzione: inserire un nome file prima di esportare.',
      noCablesSelectedExport: 'Attenzione: nessun cavo selezionato per l\'esportazione.',
      cablesDeletedSuccess: '{count} cavo/i eliminato/i con successo',
      pdfExportedSuccess: 'PDF a colori "{name}" esportato correttamente!',
      siglatureExportedSuccess: 'File siglature "{name}" esportato correttamente!',
      cablesWithMissingFields: 'Avviso: {count} cavo/i con campi mancanti: {fields}. Puoi completarli in seguito.'
    },

    // Impostazioni
    settings: {
      generalSettings: 'Impostazioni Generali',
      advancedSettings: 'Impostazioni Avanzate',
      useAWG: 'Usa AWG',
      modeLockedDuringEdit: 'Modalità bloccata durante la modifica di un cavo.',
      settingsRequiresLogin: 'Impostazioni (richiede login)',
      logout: 'Logout',
      fileName: 'Nome File:',
      revision: 'Revisione:',
      electricalSchema: 'Schema Elettrico:',
      installation: 'Installazione:',
      quantityWiring: 'Quantità Cablaggi',
      markCables: 'Marcare Cavi',
      sectionStandard: 'Standard Sezioni',
      yes: 'Sì',
      no: 'No',
      metric: 'Metrico (mm²)',
      american: 'Americano (AWG)',
      italian: 'Italiano',
      english: 'English',
      markingConfiguration: '🏷️ Configurazione Marcature',
      markingModePerConnection: 'Modalità Marcature per Collegamento',
      markingModePerConnectionDesc: 'Quando attiva, i cavi usano i collegamenti invece della siglatura per le marcature',
      modeActive: 'Modalità attiva:',
      modeActiveDesc: 'Il campo siglatura è disabilitato. Le marcature useranno i collegamenti.',
      markingHeadPosition: 'Pos. Marcatura Testa (mm)',
      markingTailPosition: 'Pos. Marcatura Coda (mm)',
      secondaryMarkings: 'Marcature Secondarie (Head2/Tail2)',
      enableHead2Tail2: 'Abilita marcature Head2/Tail2',
      secondaryMarkingContent: 'Contenuto marcature secondarie',
      additionalDistance: 'Distanza aggiuntiva (mm)',
      connection: 'Collegamento',
      signature: 'Siglatura',
      flipMarkings: 'Ribalta Marcature',
      head: 'Testa',
      central: 'Centrale',
      tail: 'Coda',
      head2FollowsHead: '💡 Head2 segue Testa, Tail2 segue Coda',
      centralMarkingAndLoop: '🎯 Marcatura Centrale e Loop Printing',
      centralMarkingType: 'Tipo Marcatura Centrale',
      nothing: 'Niente',
      numbering: 'Numerazione',
      loopPrintingAuto: 'Loop Printing Automatico',
      loopPrintingDesc: 'Con marcatura centrale attiva, puoi configurare il loop printing per posizionare più marcature distribuite uniformemente',
      loopMode: 'Modalità Loop',
      basedOnNumber: 'Basato sul Numero',
      basedOnDistance: 'Basato sulla Distanza',
      loopNumber: 'Numero di Loop',
      loopDistance: 'Distanza Loop (mm)',
      loopHowItWorks: '💡 Come funziona: Le marcature vengono distribuite uniformemente tra le posizioni testa e coda, sostituendo la marcatura centrale singola con più marcature numerate o con siglatura.',
      loopDisabled: '🔒 Per attivare il loop printing, seleziona prima un tipo di marcatura centrale',
      otherSettings: '⚙️ Altre Impostazioni',
      boldSize: 'Grandezza Grassetto',
      lengthCompensation: '🔧 Compensazione Lunghezza AC_Power',
      lengthCompensationDesc: 'Aggiunge +1mm ai cavi consecutivi con stessa lunghezza per evitare errori della macchinetta.',
      functionActive: 'Funzione attiva:',
      lengthCompensationActive: 'I cavi consecutivi con stessa lunghezza verranno esportati nel foglio AC_Power con +1mm.',
      forceBlackCables: '🖤 Forza Cavi Neri in AC_Power',
      forceBlackCablesDesc: 'Imposta tutti i cavi come NERO nel foglio AC_Power (tranne le terre GI/VE che rimangono inalterate).',
      forceBlackCablesActive: 'Tutti i cavi (tranne le terre GI/VE e YE/GN) saranno esportati come NERO nel foglio AC_Power.',
      reducePeelManual: '✂️ Riduzione Peel per Marcatura Manuale',
      reducePeelManualDesc: 'Riduce il peel a 1mm per cavi con siglatura quando la marcatura non è attiva, facilitando l\'inserimento manuale dei numerini.',
      reducePeelManualActive: 'Quando la marcatura non è attiva e il cavo ha siglatura, tutti i peel dei terminali saranno impostati a 1mm nel foglio AC_Power.',
      cablePreview: '👁️ Anteprima Cavo',
      cablePreviewDesc: 'Mostra un\'anteprima visiva del cavo corrente.',
      importTerminals: '📥 Importa Terminali',
      importTerminalsDesc: 'Importa i dati dei terminali da un file Excel (.xlsx o .xls). Il file deve contenere le colonne \'COD\', \'NOME\', \'len\', \'peel\'.',
      terminalsImportedSuccess: 'Terminali importati con successo!',
      noValidTerminalsFound: 'Nessun terminale valido trovato nel file Excel.',
      placeholderFileName: 'es. ELECB12345',
      placeholderRevision: '00',
      placeholderSchema: 'es. SCE-15032488',
      placeholderInstallation: 'es. AT0700ZM00',
      increment20mm: '💡 Incrementi di 20mm per evitare marcature troppo vicine'
    },

    // Selectors
    selectors: {
      searchColor: 'Cerca colore...',
      noColorFound: 'Nessun colore trovato',
      searchSection: 'Cerca sezione...',
      searchAWG: 'Cerca AWG...',
      noSectionFound: 'Nessuna sezione trovata',
      noAWGFound: 'Nessun AWG trovato',
      searchTerminal: 'Cerca terminale...',
      noTerminalFound: 'Nessun terminale trovato',
      terminalNotFound: 'Terminale non trovato',
      stripping: 'Spelatura',
      length: 'Lunghezza',
      peel: 'Sguainamento',
      customStripping: 'Configurazione Spelatura',
      lengthLabel: 'Lunghezza:',
      peelLabel: 'Sguainamento:',
      lengthWithUnit: 'Lunghezza (len):',
      peelWithUnit: 'Sguainamento (peel):'
    },

    // Terminals
    terminals: {
      // Groups
      singleSpades: 'Puntalini Singoli',
      doubleSpades: 'Puntalini Doppi',
      faston: 'Faston',
      forks: 'Forcine',
      eyelets: 'Occhielli',
      matenlok: 'Mate-n-lok',
      minifit: 'Mini-Fit',
      sleeves: 'Tubetti',
      others: 'Altri',
      // Terminal names
      PSW: 'Puntalino singolo Bianco',
      PSG: 'Puntalino singolo Grigio',
      PSR: 'Puntalino singolo Rosso',
      PSN: 'Puntalino singolo Nero',
      PSB: 'Puntalino singolo Blu',
      PSG4: 'Puntalino singolo Grigio 4 mm',
      PSY: 'Puntalino singolo Giallo',
      PSR10: 'Puntalino singolo Rosso 10 mm',
      PSB10: 'Puntalino singolo Blu 10 mm',
      PDW: 'Puntalino doppio Bianco',
      PDG: 'Puntalino doppio Grigio',
      PDR: 'Puntalino doppio Rosso',
      PDN: 'Puntalino doppio Nero',
      PDB: 'Puntalino doppio Blu',
      PDG4: 'Puntalino doppio Grigio 4 mm',
      PDY: 'Puntalino doppio Giallo',
      PDR10: 'Puntalino doppio Rosso 10 mm',
      FSR2_8: 'Faston scoperto Rosso 2.8mm',
      FSR4_8: 'Faston scoperto Rosso 4.8mm',
      FSR6_3: 'Faston scoperto Rosso 6.3mm',
      FCR2_8: 'Faston coperto Rosso 2.8mm',
      FCR4_8: 'Faston coperto Rosso 4.8mm',
      FCR6_3: 'Faston coperto Rosso 6.3mm',
      FCB2_8: 'Faston coperto Blu 2.8mm',
      FCB4_8: 'Faston coperto Blu 4.8mm',
      FCB6_3: 'Faston coperto Blu 6.3mm',
      FAS: 'Faston a squadra',
      FR3: 'Forcina Rossa 3mm',
      FR4: 'Forcina Rossa 4mm',
      FB3: 'Forcina Blu 3mm',
      FB4: 'Forcina Blu 4mm',
      FY3: 'Forcina Gialla 3mm',
      FY4: 'Forcina Gialla 4mm',
      OR4: 'Occhiello Rosso 4mm',
      OR5: 'Occhiello Rosso 5mm',
      OR6: 'Occhiello Rosso 6mm',
      OB4: 'Occhiello Blu 4mm',
      OB5: 'Occhiello Blu 5mm',
      OB6: 'Occhiello Blu 6mm',
      OY4: 'Occhiello Giallo 4mm',
      OY5: 'Occhiello Giallo 5mm',
      OY6: 'Occhiello Giallo 6mm',
      MLM: 'Mate-n-lok Maschio',
      MLF: 'Mate-n-lok Femmina',
      MFF: 'Mini-Fit Femmina',
      TR: 'Tubetto Rosso',
      TB: 'Tubetto Blu',
      TY: 'Tubetto Giallo',
      NS: 'No Spelatura',
      SP: 'Spelatura Personalizzata',
      customStripping: 'Spelatura {length}mm/{peel}mm',
      customStrippingOld: 'Spelatura {length}mm'
    },

    // Configurazione macchine spelafili
    machineConfig: {
      EW05: {
        general: {
          lenght: 'Lunghezza cavo',
          bladeValue: 'Diametro cavo (da misurare)',
          retractWithPercent: 'Ritrazione lama prima di rimuovere la guaina ({percent}% del Blade Value)',
          rollerLGap: 'Distanza rullo L (70% del Blade Value)',
          rollerRGap: 'Distanza rullo R (70% del Blade Value)'
        },
        outer1: {
          stripL: 'Lunghezza di spelatura',
          stripLMax: 'Lunghezza di spelatura (max {max}mm)',
          pullOffComplete: 'Rimozione guaina (completa)',
          stripR: 'Lunghezza di spelatura',
          stripRMax: 'Lunghezza di spelatura (max {max}mm)',
          pullOffRComplete: 'Rimozione guaina (completa)'
        },
        inner: {
          stripL: 'Lunghezza di spelatura',
          pullOffLComplete: 'Rimozione guaina (completa)',
          pullOffLPartial: 'Rimozione guaina (parziale)',
          bladeValue: 'Sezione fili',
          retractWithPercent: 'Ritrazione lama prima di rimuovere la guaina ({percent}% del Blade Value)',
          stripR: 'Lunghezza di spelatura',
          pullOffRComplete: 'Rimozione guaina (completa)',
          pullOffRPartial: 'Rimozione guaina (parziale)'
        },
        outer2: {
          stripL: 'Lunghezza di spelatura',
          stripLNone: 'Nessuna operazione richiesta',
          pullOffLNone: 'Nessuna operazione',
          pullOffLMax: 'Rimozione guaina (max {max}mm)',
          pullOffLComplete: 'Rimozione guaina (completa)',
          stripR: 'Lunghezza di spelatura',
          stripRNone: 'Nessuna operazione richiesta',
          pullOffRNone: 'Nessuna operazione',
          pullOffRMax: 'Rimozione guaina (max {max}mm)',
          pullOffRComplete: 'Rimozione guaina (completa)'
        },
        slitting: {
          method: 'Metodo di incisione',
          multiSegment: 'Incisioni multiple',
          knife: 'Coltellino',
          segmentInterval: 'Intervallo incisioni',
          remaining: '{mm}mm oltre i 300mm',
          knifeWarning: 'Attenzione: il coltellino rischia di incidere i cavi interni. Usare solo se necessario.'
        },
        sections: {
          outer1Single: 'Sguainatura guaina esterna',
          outer1TwoPass: 'Sguainatura guaina esterna - 1° passata',
          inner: 'Spelatura cavi interni',
          outer2: 'Sguainatura guaina esterna - 2° passata',
          slitting: 'Incisione guaina esterna',
          general: 'Generale'
        }
      }
    },

    // Export Siglature
    exportSiglature: {
      components: 'COMPONENTI',
      terminals: 'MORSETTI',
      switchesAndLights: 'INTERRUTTORI E SPIE',
      cables25_60: '2,5-6,0 MMQ SIGLE X CAVI',
      cables05_15: '0,5-1,5 MMQ SIGLE X CAVI',
      componentSign: 'SIGLA\nCOMPONENTE',
      flatTags: 'Targhette FLAT\n4x15\nELEGM45011',
      terminalSign: 'SIGLA MORSETTO',
      terminalTags: 'Targh x mors\nELEGM45021',
      switchSign: '15X27\nTARGHETTE',
      switchTags: 'Targh. 15x27\nELEGM45000',
      cable25Sign: '2,5-6,0 MMQ\nSIGLA FILO',
      cable25Tags: 'Quantità\nELEGM45005',
      cable05Sign: '0,5-1,5 MMQ\nSIGLA FILO',
      cable05Tags: 'Quantità\nELEGM45002',
      start: 'INIZIO',
      repetitions: 'RIPETIZIONI',
      end: 'FINE',
      qeExtLegend: 'QE = Quadro el\nEXT = x Refrind',
      sw: 'SW',
      type: 'TIPO'
    },

    // Export Schematic (PDF)
    exportSchematic: {
      title: 'Schema Cablaggi Elettrici',
      system: 'Sistema: EW-3035+L',
      date: 'Data',
      page: 'Pagina',
      of: 'di',
      generatedWith: 'Generato con WireCraft',
      cableQuantities: 'Riepilogo Cavi Utilizzati',
      terminalQuantities: 'Riepilogo Terminali',
      sheathQuantities: 'Riepilogo Guaine',
      technicalDetails: 'Dettagli Tecnici Completi',
      multipolar: 'Multipolari',
      total: 'TOTALE',
      multipolarCable: 'Cavo Multipolare',
      cableType: 'Tipo Cavo',
      quantity: 'Quantità',
      totalLength: 'Lungh. Totale (mm)',
      terminal: 'Terminale',
      sheath: 'Guaina',
      diameter: 'Diametro',
      pole: 'Polo',
      color: 'Colore',
      section: 'Sez.',
      signA: 'Sig.A',
      termA: 'Term.A',
      stripA: 'Spel.A',
      connA: 'Coll.A',
      signB: 'Sig.B',
      termB: 'Term.B',
      stripB: 'Spel.B',
      connB: 'Coll.B',
      pageHeader: 'Schema Cablaggi - ',
      noName: 'Senza nome'
    },

    // Landing Page
    landing: {
      welcomeTitle: 'Benvenuto in WireCraft',
      welcomeSubtitle: 'Schema Cablaggi Elettrici',
      description: 'Progetta, organizza ed esporta i tuoi cablaggi con un\'interfaccia intuitiva e calcoli automatici per macchine da taglio e spelatura.',
      createNew: 'Crea Nuovo Progetto',
      importProject: 'Importa Progetto Esistente',
      featuresTitle: 'Tutto ciò di cui hai bisogno in un unico strumento',
      feature1Title: 'Design Visuale e Intuitivo',
      feature1Desc: 'Costruisci lo schema del cavo visivamente, con cavi singoli, guaine e cavi multipolari in un\'interfaccia pulita.',
      feature2Title: 'Pronto per la Produzione',
      feature2Desc: 'Ottieni lunghezze, sguainamenti, e calcoli esatti per macchine come EW-3035+L o per la marcatura.',
      feature3Title: 'Esportazione Flessibile',
      feature3Desc: 'Esporta dati in Excel, PDF grafici, o liste siglature con un singolo click.'
    }
  },

  en: {
    // General
    common: {
      save: 'Save',
      cancel: 'Cancel',
      delete: 'Delete',
      edit: 'Edit',
      add: 'Add',
      close: 'Close',
      confirm: 'Confirm',
      search: 'Search',
      filter: 'Filter',
      export: 'Export',
      import: 'Import',
      settings: 'Settings',
      language: 'Language'
    },

    // Cable form
    cableForm: {
      standardCable: 'Standard Cable',
      multipolarCable: 'Multipolar Cable',
      newCable: 'New Cable',
      editStandardCable: 'Edit Standard Cable',
      editMultipolarCable: 'Edit Multipolar Cable',
      siglatura: 'Signature',
      group: 'Group',
      color: 'Color',
      section: 'Section',
      length: 'Length',
      lengthMm: 'Length (mm)',
      terminalA: 'Terminal A',
      terminalB: 'Terminal B',
      connectionA: 'Connection A',
      connectionB: 'Connection B',
      sheath: 'Sheath',
      addSheath: 'New Sheath',
      deleteSheath: 'Delete Sheath',
      sheathType: 'Sheath Type',
      sheathDiameter: 'Diameter',
      sheathLength: 'Length',
      pvc: 'PVC',
      braided: 'Braided',
      optional: '(optional)',
      noSheath: 'No sheath',
      noSheathCreated: 'No sheath created',
      enterDiameterLength: 'Enter diameter and length',
      deleteSheathConfirm: 'Delete this sheath? Cables using it will be updated.',
      addNewSheath: 'Add New Sheath',
      cancel: 'Cancel',
      add: 'Add',
      diameterMm: 'Diameter (mm)',
      placeholderDiameter: 'e.g. 3.5, 5, 8',
      placeholderLength: 'e.g. 200, 500',
      sheathNote: '💡 Note: Cables with the same sheath will be physically grouped together.',
      addSheathButton: 'Add Sheath',
      cableName: 'Cable Name',
      baseLength: 'Base Length (mm)',
      poles: 'Poles',
      addNewPole: 'Add new pole',
      pole: 'Pole',
      poleSignatureA: 'Signature A',
      poleSignatureB: 'Signature B',
      poleLengthA: 'Length A (mm)',
      poleLengthB: 'Length B (mm)',
      duplicatePole: 'Duplicate this pole',
      removePole: 'Remove pole',
      addMultipolarCable: 'Add Multipolar Cable',
      cancelEdit: 'Cancel Edit',
      placeholderCableName: 'e.g. Multipolar Cable',
      placeholderPoleSignatureA: 'e.g. 60, R1',
      placeholderPoleSignatureB: 'e.g. 61, R2',
      disabledConnectionMode: '(disabled - connection mode)',
      disabledUseConnectionMode: 'Disabled - use connection mode',
      placeholderSignature: 'e.g. 60, R1, L',
      placeholderGroup: 'e.g. A, 1, GRP1',
      placeholderConnectionA: 'e.g. F6.7 (1), TERM. 61',
      placeholderConnectionB: 'e.g. TERM. 61, K6.2 (A1)',
      addCable: 'Add Cable',
      saveChanges: 'Save Changes',
      saveAsNew: 'Save as New',
      keepAllSettings: 'Keep all settings for next cable',
      addArrowUp: 'Add UP arrow (▲)',
      addArrowDown: 'Add DOWN arrow (▼)',
      addVirtualDot: 'Add virtual connection (·)',
      swapTerminals: 'Swap terminals and connections A ↔ B'
    },

    // Cable list


    // Schematic view
    schematic: {
      schematicView: 'Schematic View',
      schematicViewTitle: 'Cable Schematic View',
      cable: 'cable',
      cables: 'cables',
      singleCable: 'Single',
      cableSegments: 'cable segments',
      cableSegmentsInGroups: 'in {count} groups',
      cablesInSubgroups: 'cables in {count} subgroups',
      group: 'Group',
      forcedGroup: 'Forced Group',
      multiple: 'Multiple',
      sheath: 'Sheath',
      multipolarCable: 'Multipolar',
      hybrid: 'Hybrid',
      groupLabel: 'Group:',
      pdfColors: 'PDF Colors',
      noCablesSelected: 'Warning: no cables selected for export.',
      sortBy: 'Sort by:',
      numbering: 'Numbering',
      signature: 'Signature',
      color: 'Color',
      section: 'Section',
      colorSection: 'Color + Section',
      groupSort: 'Group',
      sheathLabel: 'Sheath:',
      sheathNumber: 'Sheath #{id}',
      cableLabel: 'Cable:',
      nestedViewToggle: 'Nested view (beta)'
    },

    // Stripping machine configuration panel
    machineConfigPanel: {
      title: 'Machine Configuration',
      subtitle: 'Parameters computed from multipolar cable',
      enabled: 'ON',
      disabled: 'OFF',
      innerOff: 'No inner stripping required',
      innerOn: 'Inner stripping required by terminals with peel'
    },

    // Messages
    messages: {
      warning: 'Warning:',
      success: 'Success:',
      error: 'Error:',
      closeWarning: 'Close warning',
      closeSuccess: 'Close message',
      closeError: 'Close error'
    },

    // Quantities
    quantities: {
      summaryTitle: 'Quantities Summary',
      cableQuantities: 'Cable Quantities',
      terminalQuantities: 'Terminal Quantities',
      sheathQuantities: 'Sheath Quantities',
      signatureCalculation: 'Signatures and Terminals Calculation',
      exportSignatures: 'Export Signatures',
      cableType: 'Cable Type',
      terminalType: 'Terminal Type',
      sheathType: 'Sheath Type',
      quantity: 'Quantity',
      diameter: 'Diameter',
      totalLength: 'Total Length',
      realTotal: 'Real Total',
      realLength: 'Real Length',
      total: 'TOTAL',
      varieties: 'varieties',
      multipleProduction: 'Multiple Production: {count} identical wirings',
      multipleProductionDesc: 'Real totals are multiplied by {count}. Verify quantities before ordering materials.',
      cablaggi: 'WIRINGS',
      noCablesInserted: 'No cables inserted',
      noSheaths: 'No sheaths used',
      addCablesToCalculate: 'Add cables to calculate signatures and terminals',
      loadingData: 'Loading data...',
      summaryTotals: '📊 Summary Totals',
      signatures05_15: 'Signatures 0.5-1.5 mm²',
      signatures25_6: 'Signatures 2.5-6.0 mm²',
      flatTags: 'FLAT 4x15 Tags',
      terminals: 'Terminals',
      totalOverall: 'Overall Total',
      start: 'Start',
      repeat: 'Repeat',
      end: 'End',
      totalLabel: 'totals',
      terminal: 'Terminal',
      sheathPVC: 'PVC',
      sheathBraided: 'Braided'
    },

    // Cable list
    cableList: {
      cable: 'Cable',
      cableLabel: 'Cable:',
      connectedCables: 'connected cables',
      cables: 'cables',
      multiple: 'Multiple',
      sheath: 'Sheath',
      sheathLabel: 'Sheath:',
      subgroup: 'subgroup',
      subgroups: 'subgroups',
      inSubgroups: 'in {count} {word}',
      hasProblems: 'Has problems',
      noCablesInserted: 'No cables inserted',
      addCablesToSeeSchema: 'Add cables to see the connection schema',
      selected: 'selected',
      selectAll: 'Select all',
      deselectAll: 'Deselect all',
      cableList: 'Cable List',
      importXlsx: 'Import XLSX',
      exportXlsx: 'Export XLSX',
      sortOrder: 'Order:',
      selectSortType: 'Select sort type',
      selectCables: 'Select Cables:',
      manualSort: 'Manual Sort:',
      exportForEW3035: 'Export for EW-3035+L:',
      deleteSelected: 'Delete',
      deleteSelectedTitle: 'Delete {count} selected cable/s',
      sortByNumber: 'Numbering',
      sortBySignature: 'Signature',
      sortByColor: 'Color',
      sortBySection: 'Section',
      sortByColorSection: 'Color + Section',
      sortByGroup: 'Group',
      loading: 'Loading...'
    },

    // Validation
    validation: {
      duplicateCable: 'Duplicate cable of',
      missingSignature: 'Missing signature',
      invalidTerminal: 'Invalid terminal',
      invalidColor: 'Invalid color',
      invalidSection: 'Invalid section',
      hasIssues: 'Has issues',
      issuesList: 'Issues:',
      terminalA: 'Terminal A',
      terminalB: 'Terminal B',
      color: 'Color',
      terminalAError: 'Terminal A: {error}',
      terminalBError: 'Terminal B: {error}',
      colorError: 'Color: {error}',
      sectionError: 'Invalid section',
      poleError: 'Pole {index}: {error}',
      cableNameMissing: 'Cable name missing',
      emptyTerminal: 'Empty terminal',
      invalidSPLength: 'SP terminal with invalid length: {length}',
      invalidSPPeel: 'SP terminal with invalid peel: {peel}',
      unknownTerminal: 'Unknown terminal: {terminal}',
      emptyColor: 'Empty color',
      unknownColor: 'Unknown color: {color}',
      sectionUnderMin: 'Terminal {terminal}: {sezione} section is below minimum (min {min})',
      sectionOverMaxTotal: 'Terminal {terminal}: total section {sum} exceeds terminal capacity (max {max})',
      sectionOverMaxSingle: 'Terminal {terminal}: {sezione} section exceeds terminal maximum (max {max})',
      duplicateCableOf: 'Duplicate cable of: {cables}',
      cableInsertedMissingFields: 'Cable inserted with missing fields: {fields}. You can complete them later.',
      multipolarCableInsertedMissingFields: 'Multipolar cable inserted with missing fields: {fields}. You can complete them later.'
    },

    // File operations
    fileOperations: {
      exportSuccess: 'Export completed',
      importSuccess: 'Import completed',
      fileImportedSuccess: 'File "{name}" imported successfully!',
      fileExportedSuccess: 'File "{name}" exported successfully!',
      fileExportedSuccessSelected: 'File "{name}" exported successfully! ({exported} of {total} cables selected)',
      fileExportedSuccessTotal: 'File "{name}" exported successfully! ({exported} total cables)',
      importError: 'Error importing file: {error}',
      exportError: 'Error during export: {error}',
      exportSiglatureError: 'Error exporting signatures: {error}',
      exportPDFError: 'PDF export error: {error}',
      pdfLibrariesError: 'Error loading PDF libraries. Please try again.',
      noFileNameWarning: 'Warning: enter a file name before exporting.',
      noCablesSelectedExport: 'Warning: no cables selected for export.',
      cablesDeletedSuccess: '{count} cable/s deleted successfully',
      pdfExportedSuccess: 'Color PDF "{name}" exported successfully!',
      siglatureExportedSuccess: 'Signatures file "{name}" exported successfully!',
      cablesWithMissingFields: 'Warning: {count} cable/s with missing fields: {fields}. You can complete them later.'
    },

    // Settings
    settings: {
      generalSettings: 'General Settings',
      advancedSettings: 'Advanced Settings',
      useAWG: 'Use AWG',
      modeLockedDuringEdit: 'Mode locked while editing a cable.',
      settingsRequiresLogin: 'Settings (requires login)',
      logout: 'Logout',
      fileName: 'File Name:',
      revision: 'Revision:',
      electricalSchema: 'Electrical Schema:',
      installation: 'Installation:',
      quantityWiring: 'Wiring Quantity',
      markCables: 'Mark Cables',
      sectionStandard: 'Section Standard',
      yes: 'Yes',
      no: 'No',
      metric: 'Metric (mm²)',
      american: 'American (AWG)',
      italian: 'Italian',
      english: 'English',
      markingConfiguration: '🏷️ Marking Configuration',
      markingModePerConnection: 'Marking Mode per Connection',
      markingModePerConnectionDesc: 'When active, cables use connections instead of signature for markings',
      modeActive: 'Mode active:',
      modeActiveDesc: 'The signature field is disabled. Markings will use connections.',
      markingHeadPosition: 'Head Marking Position (mm)',
      markingTailPosition: 'Tail Marking Position (mm)',
      secondaryMarkings: 'Secondary Markings (Head2/Tail2)',
      enableHead2Tail2: 'Enable Head2/Tail2 markings',
      secondaryMarkingContent: 'Secondary marking content',
      additionalDistance: 'Additional distance (mm)',
      connection: 'Connection',
      signature: 'Signature',
      flipMarkings: 'Flip Markings',
      head: 'Head',
      central: 'Central',
      tail: 'Tail',
      head2FollowsHead: '💡 Head2 follows Head, Tail2 follows Tail',
      centralMarkingAndLoop: '🎯 Central Marking and Loop Printing',
      centralMarkingType: 'Central Marking Type',
      nothing: 'Nothing',
      numbering: 'Numbering',
      loopPrintingAuto: 'Automatic Loop Printing',
      loopPrintingDesc: 'With central marking active, you can configure loop printing to place multiple markings evenly distributed',
      loopMode: 'Loop Mode',
      basedOnNumber: 'Based on Number',
      basedOnDistance: 'Based on Distance',
      loopNumber: 'Number of Loops',
      loopDistance: 'Loop Distance (mm)',
      loopHowItWorks: '💡 How it works: Markings are evenly distributed between head and tail positions, replacing the single central marking with multiple numbered or signature markings.',
      loopDisabled: '🔒 To activate loop printing, first select a central marking type',
      otherSettings: '⚙️ Other Settings',
      boldSize: 'Bold Size',
      lengthCompensation: '🔧 AC_Power Length Compensation',
      lengthCompensationDesc: 'Adds +1mm to consecutive cables with the same length to avoid machine errors.',
      functionActive: 'Function active:',
      lengthCompensationActive: 'Consecutive cables with the same length will be exported to the AC_Power sheet with +1mm.',
      forceBlackCables: '🖤 Force Black Cables in AC_Power',
      forceBlackCablesDesc: 'Sets all cables as BLACK in the AC_Power sheet (except GI/VE grounds which remain unchanged).',
      forceBlackCablesActive: 'All cables (except GI/VE and YE/GN grounds) will be exported as BLACK in the AC_Power sheet.',
      reducePeelManual: '✂️ Reduce Peel for Manual Marking',
      reducePeelManualDesc: 'Reduces peel to 1mm for cables with signature when marking is not active, facilitating manual insertion of numbers.',
      reducePeelManualActive: 'When marking is not active and the cable has a signature, all terminal peels will be set to 1mm in the AC_Power sheet.',
      cablePreview: '👁️ Cable Preview',
      cablePreviewDesc: 'Shows a visual preview of the current cable.',
      importTerminals: '📥 Import Terminals',
      importTerminalsDesc: 'Import terminal data from an Excel file (.xlsx or .xls). The file must contain columns \'COD\', \'NOME\', \'len\', \'peel\'.',
      terminalsImportedSuccess: 'Terminals imported successfully!',
      noValidTerminalsFound: 'No valid terminals found in the Excel file.',
      placeholderFileName: 'e.g. ELECB12345',
      placeholderRevision: '00',
      placeholderSchema: 'e.g. SCE-15032488',
      placeholderInstallation: 'e.g. AT0700ZM00',
      increment20mm: '💡 Increments of 20mm to avoid markings too close'
    },

    // Selectors
    selectors: {
      searchColor: 'Search color...',
      noColorFound: 'No color found',
      searchSection: 'Search section...',
      searchAWG: 'Search AWG...',
      noSectionFound: 'No section found',
      noAWGFound: 'No AWG found',
      searchTerminal: 'Search terminal...',
      noTerminalFound: 'No terminal found',
      terminalNotFound: 'Terminal not found',
      stripping: 'Stripping',
      length: 'Length',
      peel: 'Peel',
      customStripping: 'Stripping Configuration',
      lengthLabel: 'Length:',
      peelLabel: 'Peel:',
      lengthWithUnit: 'Length (len):',
      peelWithUnit: 'Peel (peel):'
    },

    // Terminals
    terminals: {
      // Groups
      singleSpades: 'Single Ferrules',
      doubleSpades: 'Double Ferrules',
      faston: 'Faston',
      forks: 'Forks',
      eyelets: 'Rings',
      matenlok: 'Mate-n-lok',
      minifit: 'Mini-Fit',
      sleeves: 'Sleeves',
      others: 'Others',
      // Terminal names
      PSW: 'White Single Ferrule',
      PSR: 'Red Single Ferrule',
      PSN: 'Black Single Ferrule',
      PSB: 'Blue Single Ferrule',
      PSG: 'Gray Single Ferrule 0.75 mm',
      PSG4: 'Gray Single Ferrule 4 mm',
      PSY: 'Yellow Single Ferrule',
      PSR10: 'Red Single Ferrule 10 mm',
      PSB10: 'Blue Single Ferrule 10 mm',
      PDW: 'White Double Ferrule',
      PDR: 'Red Double Ferrule',
      PDN: 'Black Double Ferrule',
      PDB: 'Blue Double Ferrule',
      PDG: 'Gray Double Ferrule 0.75 mm',
      PDG4: 'Gray Double Ferrule 4 mm',
      PDY: 'Yellow Double Ferrule',
      PDR10: 'Red Double Ferrule 10 mm',
      FSR2_8: 'Red Open Faston 2.8mm',
      FSR4_8: 'Red Open Faston 4.8mm',
      FSR6_3: 'Red Open Faston 6.3mm',
      FCR2_8: 'Red Covered Faston 2.8mm',
      FCR4_8: 'Red Covered Faston 4.8mm',
      FCR6_3: 'Red Covered Faston 6.3mm',
      FCB2_8: 'Blue Covered Faston 2.8mm',
      FCB4_8: 'Blue Covered Faston 4.8mm',
      FCB6_3: 'Blue Covered Faston 6.3mm',
      FAS: 'Right Angle Faston',
      FR3: 'Red Fork 3mm',
      FR4: 'Red Fork 4mm',
      FB3: 'Blue Fork 3mm',
      FB4: 'Blue Fork 4mm',
      FY3: 'Yellow Fork 3mm',
      FY4: 'Yellow Fork 4mm',
      OR4: 'Red Ring 4mm',
      OR5: 'Red Ring 5mm',
      OR6: 'Red Ring 6mm',
      OB4: 'Blue Ring 4mm',
      OB5: 'Blue Ring 5mm',
      OB6: 'Blue Ring 6mm',
      OY4: 'Yellow Ring 4mm',
      OY5: 'Yellow Ring 5mm',
      OY6: 'Yellow Ring 6mm',
      MLM: 'Mate-n-lok Male',
      MLF: 'Mate-n-lok Female',
      MFF: 'Mini-Fit Female',
      TR: 'Head-Head Red Joint',
      TB: 'Head-Head Blue Joint',
      TY: 'Head-Head Yellow Joint',
      NS: 'No Stripping',
      SP: 'Custom Stripping',
      customStripping: 'Stripping {length}mm/{peel}mm',
      customStrippingOld: 'Stripping {length}mm'
    },

    // Stripping machines configuration
    machineConfig: {
      EW05: {
        general: {
          lenght: 'Cable length',
          bladeValue: 'Cable diameter (to be measured)',
          retractWithPercent: 'Blade retraction before removing sheath ({percent}% of Blade Value)',
          rollerLGap: 'Roller L. gap (70% of Blade Value)',
          rollerRGap: 'Roller R. gap (70% of Blade Value)'
        },
        outer1: {
          stripL: 'Stripping length',
          stripLMax: 'Stripping length (max {max}mm)',
          pullOffComplete: 'Sheath removal (complete)',
          stripR: 'Stripping length',
          stripRMax: 'Stripping length (max {max}mm)',
          pullOffRComplete: 'Sheath removal (complete)'
        },
        inner: {
          stripL: 'Stripping length',
          pullOffLComplete: 'Sheath removal (complete)',
          pullOffLPartial: 'Sheath removal (partial)',
          bladeValue: 'Wire section',
          retractWithPercent: 'Blade retraction before removing sheath ({percent}% of Blade Value)',
          stripR: 'Stripping length',
          pullOffRComplete: 'Sheath removal (complete)',
          pullOffRPartial: 'Sheath removal (partial)'
        },
        outer2: {
          stripL: 'Stripping length',
          stripLNone: 'No operation required',
          pullOffLNone: 'No operation',
          pullOffLMax: 'Sheath removal (max {max}mm)',
          pullOffLComplete: 'Sheath removal (complete)',
          stripR: 'Stripping length',
          stripRNone: 'No operation required',
          pullOffRNone: 'No operation',
          pullOffRMax: 'Sheath removal (max {max}mm)',
          pullOffRComplete: 'Sheath removal (complete)'
        },
        slitting: {
          method: 'Incision method',
          multiSegment: 'Multi-segment cuts',
          knife: 'Full knife',
          segmentInterval: 'Segment interval',
          remaining: '{mm}mm beyond 300mm',
          knifeWarning: 'Warning: the knife may cut into internal wires. Use only when necessary.'
        },
        sections: {
          outer1Single: 'Outer sheath stripping',
          outer1TwoPass: 'Outer sheath stripping - 1st step',
          inner: 'Inner cables stripping',
          outer2: 'Outer sheath stripping - 2nd step',
          slitting: 'Outer sheath slitting',
          general: 'General'
        }
      }
    },

    // Export Siglature
    exportSiglature: {
      components: 'COMPONENTS',
      terminals: 'TERMINALS',
      switchesAndLights: 'SWITCHES AND LIGHTS',
      cables25_60: '2.5-6.0 MMQ WIRE SIGNS',
      cables05_15: '0.5-1.5 MMQ WIRE SIGNS',
      componentSign: 'COMPONENT\nSIGN',
      flatTags: 'FLAT Tags\n4x15\nELEGM45011',
      terminalSign: 'TERMINAL SIGN',
      terminalTags: 'Term. Tags\nELEGM45021',
      switchSign: '15X27\nTAGS',
      switchTags: 'Tags 15x27\nELEGM45000',
      cable25Sign: '2.5-6.0 MMQ\nWIRE SIGN',
      cable25Tags: 'Quantity\nELEGM45005',
      cable05Sign: '0.5-1.5 MMQ\nWIRE SIGN',
      cable05Tags: 'Quantity\nELEGM45002',
      start: 'START',
      repetitions: 'REPETITIONS',
      end: 'END',
      qeExtLegend: 'QE = Electric Panel\nEXT = External',
      sw: 'SW',
      type: 'TYPE'
    },

    // Export Schematic (PDF)
    exportSchematic: {
      title: 'Electrical Wiring Schematic',
      system: 'System: EW-3035+L',
      date: 'Date',
      page: 'Page',
      of: 'of',
      generatedWith: 'Generated with WireCraft',
      cableQuantities: 'Cable Usage Summary',
      terminalQuantities: 'Terminals Summary',
      sheathQuantities: 'Sheaths Summary',
      technicalDetails: 'Full Technical Details',
      multipolar: 'Multipolar',
      total: 'TOTAL',
      multipolarCable: 'Multipolar Cable',
      cableType: 'Cable Type',
      quantity: 'Quantity',
      totalLength: 'Total Length (mm)',
      terminal: 'Terminal',
      sheath: 'Sheath',
      diameter: 'Diameter',
      pole: 'Pole',
      color: 'Color',
      section: 'Sect.',
      signA: 'Sign.A',
      termA: 'Term.A',
      stripA: 'Strip.A',
      connA: 'Conn.A',
      signB: 'Sign.B',
      termB: 'Term.B',
      stripB: 'Strip.B',
      connB: 'Conn.B',
      pageHeader: 'Wiring Schematic - ',
      noName: 'Untitled'
    },

    // Landing Page
    landing: {
      welcomeTitle: 'Welcome to WireCraft',
      welcomeSubtitle: 'Electrical Wiring Schematic',
      description: 'Design, organize and export your wirings with an intuitive interface and automatic calculations for cutting and stripping machines.',
      createNew: 'Start New Project',
      importProject: 'Import Existing Project',
      featuresTitle: 'Everything you need in one tool',
      feature1Title: 'Visual & Intuitive Design',
      feature1Desc: 'Build the cable schematic visually, with single cables, sheaths, and multipolar cables in a clean interface.',
      feature2Title: 'Production Ready',
      feature2Desc: 'Get exact lengths, strippings, and calculations for machines like EW-3035+L or wire marking.',
      feature3Title: 'Flexible Export',
      feature3Desc: 'Export data to Excel, graphical PDFs, or signature lists with a single click.'
    }
  }
};

